import { ReactElement } from 'react';
import PasswordResetSuccess from './views/PasswordResetSuccess';

const PasswordResetSuccessRoute = (): ReactElement => (
  <PasswordResetSuccess />
);

export default PasswordResetSuccessRoute;
